import type { ReactNode } from 'react'

interface StatTileProps {
  label: string
  value: ReactNode
  tone?: 'default' | 'primary' | 'success' | 'warning' | 'danger'
  hint?: string
}

export function StatTile({ label, value, tone = 'default', hint }: StatTileProps) {
  return (
    <div className={`stat-tile stat-tile--${tone}`} title={hint}>
      <span className="stat-tile__label">{label}</span>
      <span className="stat-tile__value">{value}</span>
    </div>
  )
}
